<template>
  <FormLayout>
    <UploadFileWithDownloadableFileList
      :upload-filters="uploadFilters"
      :display-filters="financialStatementUploadMatcher"
      :empty-prompt="messagePrompt"
      theme="onboarding"
      no-list
      :files="financialStatements"
      @dropzoneClicked="trackEvent(SEGMENT_EVENTS.fe_upload_btn)"
      @trackUploadedDocClicked="trackEvent(SEGMENT_EVENTS.fe_download_link)"
      @docsUploaded="trackDocsUploaded"
      @fileRemove="removeUpload"
    />
  </FormLayout>
</template>

<script>
import analytics, { SEGMENT_EVENTS } from '@/utils/analytics';
import { isMobileMixin } from '@/utils/vue-mixins';
import { mapGetters } from 'vuex';
import { ENTITY_TYPE, BUSINESS_DOC_TYPE } from '@clearbanc/data-common-types';
import UploadFileWithDownloadableFileList from '@/components/upload/UploadFileWithDownloadableFileList.vue';
import FormLayout from '@/components/layouts/FormLayout.vue';

export default {
  components: {
    UploadFileWithDownloadableFileList,
    FormLayout,
  },
  mixins: [isMobileMixin],
  props: {
    eventTrackingFields: { type: Object, default: () => {} },
  },
  data() {
    return {
      SEGMENT_EVENTS,
    };
  },
  computed: {
    ...mapGetters(['business', 'financialStatementUploadMatcher']),
    uploadFilters() {
      return {
        entity: ENTITY_TYPE.BUSINESS,
        type: BUSINESS_DOC_TYPE.FINANCIAL_STATEMENTS,
        businessId: this.business.id,
      };
    },
    financialStatements() {
      return this.$store.getters.uploadsMatching(
        this.financialStatementUploadMatcher,
      );
    },
    messagePrompt() {
      return this.isMobile()
        ? this.$t('common.messagePrompt.browse')
        : this.$t('common.messagePrompt.dragAndDropFilesOrBrowse');
    },
  },
  methods: {
    trackEvent(name, props) {
      analytics.track(name, { ...this.eventTrackingFields, ...props });
    },
    removeUpload(id) {
      this.trackEvent(SEGMENT_EVENTS.fe_delete_document);
      this.$store.dispatchApiAction('DELETE_USER_UPLOAD', { id });
    },
    trackDocsUploaded(uploadData) {
      this.$emit('fileUploaded', uploadData);
    },
  },
};
</script>
